<template>
    <div class="dataAny">
        <!--上面部分-->
        <culumTop :eventInfoData="courseinfo"></culumTop>
        <!--下面部分-->
        <div class="tabsBottom padding-20 bgc box-shadow">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="学员" name="first"><dataAny1 @getCourInfo="_getCourInfo"></dataAny1></el-tab-pane>
                <el-tab-pane label="订单" name="second" lazy><dataAny2></dataAny2></el-tab-pane>
                <el-tab-pane label="学习效果" name="three" lazy><dataAny3></dataAny3></el-tab-pane>
                <el-tab-pane label="交易效果" name="four" lazy><dataAny4></dataAny4></el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import CulumTop from './components/culumTop'
    import DataAny1 from './components/dataAny/dataAny1'
    import DataAny2 from './components/dataAny/dataAny2'
    import DataAny3 from './components/dataAny/dataAny3'
    import DataAny4 from './components/dataAny/dataAny4'
    export default {
        name: "CurriculumDataAny",
        data(){
            return{
                activeName:'first',
                courseinfo:{},
                isFresh:''
            }
        },
        methods:{
            handleClick(){

            },
            _getCourInfo(data){
                this.courseinfo=data
            }
        },
        components:{
            CulumTop, DataAny1, DataAny2, DataAny3, DataAny4
        }
    }
</script>

<style scoped lang="scss">
    .dataAny{
        .tabsBottom{
            margin-top: 20px;
        }
    }
</style>
